import { MenuItemRoleGrid } from "./MenuItemRoleGrid";
import { ReportRoleGrid } from "./ReportRoleGrid";
import { IPermissionGrid } from "./IPermissionGrid";
import { PermissionObjectIds } from "../../Enums/PermissionObjectIds";
import { ExcelReportRoleGrid } from "./ExcelReportRoleGrid";
import { ExcelExportRoleGrid } from "./ExcelExportRoleGrid";
import { DashboardShortcutRoleGrid } from "./DashboardShortcutRoleGrid";

export class PermissionGridFactory {
    private grids: IPermissionGrid<any>[] = [];

    createOrGet(objectId: PermissionObjectIds): IPermissionGrid<any> {
        if (objectId === PermissionObjectIds.MenuItemRole) {
            let grid = this.grids.find((grid) => grid.id === "MenuItemRole");
            if (!grid) {
                grid = new MenuItemRoleGrid();
                this.grids.push(grid);
            }
            return grid;
        } else if (objectId === PermissionObjectIds.ReportRole) {
            let grid = this.grids.find((grid) => grid.id === "ReportRole");
            if (!grid) {
                grid = new ReportRoleGrid();
                this.grids.push(grid);
            }
            return grid;
        } else if (objectId === PermissionObjectIds.DashboardShortcutRole) {
            let grid = this.grids.find((grid) => grid.id === "DashboardShortcutRoles");
            if (!grid) {
                grid = new DashboardShortcutRoleGrid();
                this.grids.push(grid);
            }
            return grid;
        } else if (objectId === PermissionObjectIds.ExcelDropdownReportRole) {
            let grid = this.grids.find((grid) => grid.id === "ExcelReportRole");
            if (!grid) {
                grid = new ExcelReportRoleGrid();
                this.grids.push(grid);
            }
            return grid;
        } else if (objectId === PermissionObjectIds.ExcelExportRole) {
            let grid = this.grids.find((grid) => grid.id === "ExcelExportRoles");
            if (!grid) {
                grid = new ExcelExportRoleGrid();
                this.grids.push(grid);
            }
            return grid;
        }
    }
}
